<template>
  <header>
    <!-- Header Start -->
    <div class="header-area">
      <div class="main-header">
        <div class="header-top main-bg d-md-block">
          <div class="container">
            <div class="col-xl-12">
              <div class="row d-flex justify-content-between align-items-center">
                <div class="header-info-left">
                  <ul>
                    <li>Hà Nội, Việt Nam</li>
                    <li>
                      <span id="clock">{{ date1 }}</span>
                    </li>
                  </ul>
                </div>
                <div class="header-info-right hidden-mobile" v-if="!isAuthenticated">
                  <div class="header-login">
                    <a href="/login">Đăng nhập</a>
                    <router-link to="/register">Đăng ký</router-link>
                  </div>
                </div>
                <div class="header-info-right hidden-mobile" v-else>
                  <div class="header-login">
                    <router-link to="/profile" style="text-decoration: underline;">{{
                      currentUser.username
                    }}</router-link>
                    <a v-on:click="logout()">Thoát</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="header-mid d-none d-md-block">
          <div class="container">
            <div class="row d-flex align-items-center">
              <!-- Logo -->
              <div class="col-xl-2 col-lg-2 col-md-2">
                <div class="logo">
                  <router-link to="/">
                    <img src="@/assets/images/logo.svg" alt="" />
                  </router-link>
                </div>
              </div>
              <div class="col-xl-10 col-lg-10 col-md-10">
                <h1 class="cpn-name">
                  <strong> CÔNG TY ĐẤU GIÁ HỢP DANH SỐ 5 - QUỐC GIA</strong><br />
                  TỔ CHỨC THỰC HIỆN ĐẤU GIÁ TRỰC TUYẾN <strong>ĐẦU TIÊN</strong> TẠI VIỆT NAM
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div
          class="header-bottom header-sticky"
          v-bind:class="{ 'sticky-bar sticky': scrollPosition > 200, ' mr-t': scrollPosition < 200 }"
        >
          <div class="container">
            <div class="row align-items-center">
              <div
                class="col-xl-11 col-lg-11 col-md-12 header-flex"
                v-bind:class="{ 'sticky-flex': scrollPosition > 200 }"
              >
                <!-- sticky -->
                <div class="sticky-logo info-open">
                  <a href="/"><img src="@/assets/images/logo.svg" alt=""/></a>
                </div>
                <!-- Main-menu -->
                <div class="main-menu d-none d-md-block">
                  <nav>
                    <ul id="navigation">
                      <li><router-link style="text-transform: uppercase;" to="/">Trang chủ</router-link></li>
                      <li>
                        <a style="text-transform: uppercase;" href="#">Giới thiệu</a>
                        <ul class="submenu">
                          <li>
                            <router-link style="text-transform: uppercase;" to="/about"
                              >Lịch sử hình thành và phát triển</router-link
                            >
                          </li>
                          <li>
                            <router-link style="text-transform: uppercase;" to="/auctioneers"
                              >Danh sách đấu giá viên</router-link
                            >
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a style="text-transform: uppercase;" href="/#nav-tabContent" class="">THÔNG BÁO MỜI ĐẤU GIÁ</a>
                      </li>
                      <li>
                        <a href="/auction/room" class="blinking" style="text-transform: uppercase;">Phòng đấu giá</a>
                      </li>
                      <li>
                        <router-link style="text-transform: uppercase;" class="" to="/auction/result"
                          >Kết quả đấu giá
                        </router-link>
                      </li>
                      <li><a style="text-transform: uppercase;" href="#">Tin tức - Sự kiện</a></li>
                    </ul>
                  </nav>
                </div>
              </div>
              <div class="col-xl-1 col-lg-1 col-md-4">
                <div class="header-right-btn f-right d-none d-lg-block">
                  <i class="fas fa-search special-tag"></i>
                  <div class="search-box">
                    <form action="#">
                      <input type="text" placeholder="Tìm kiếm" />
                    </form>
                  </div>
                </div>
              </div>
              <!-- Mobile Menu -->
              <!-- <div class="col-12" style="display: none;">
                                <div class="mobile_menu d-block d-md-none">
                                    <div class="slicknav_menu">
                                        <a v-on:click="isClick=!isClick" aria-haspopup="true" role="button" tabindex="0" class="slicknav_btn slicknav_collapsed" style="">
                                            <span class="slicknav_menutxt">MENU</span>
                                            <span class="slicknav_icon">
                                                <span class="slicknav_icon-bar"></span>
                                                <span class="slicknav_icon-bar"></span>
                                                <span class="slicknav_icon-bar"></span>
                                            </span>
                                        </a>
                                        <ul class="slicknav_nav slicknav_hidden" aria-hidden="true" role="menu" v-if="isClick">
                                            <li><router-link @click.native="hideMenu" to="/">TRANG CHỦ</router-link></li>
                                            <li>
                                                <a href="#" style="text-transform: uppercase;" role="menuitem">Giới thiệu</a>
                                                <ul class="submenu">
                                                    <li><router-link style="text-transform: uppercase;" @click.native="hideMenu" to="/about">Lịch sử hình thành và phát triển</router-link></li>
                                                    <li><router-link style="text-transform: uppercase;" @click.native="hideMenu" to="/auctioneers">Danh sách đấu giá viên</router-link></li>
                                                </ul>
                                            </li>
                                            <li><router-link @click.native="hideMenu" to="/auction/room">THÔNG BÁO MỜI ĐẤU GIÁ</router-link></li>
                                            <li><a href="/auction/room" class="blinking">PHÒNG ĐẤU GIÁ</a></li>
                                            <li>
                                                <a href="#" role="menuitem">THỦ TỤC SAU ĐẤU GIÁ</a>
                                                <ul class="submenu">
                                                    <li><router-link style="text-transform: uppercase;" to="/auction/result">Kết quả đấu giá</router-link></li>
                                                    <li><a style="text-transform: uppercase;" href="#">Hợp đồng mua bán tài sản</a></li>
                                                    <li><a style="text-transform: uppercase;" href="#">Bàn giao tài sản</a></li>
                                                    <li><a style="text-transform: uppercase;" href="#">Hỗ trợ giao hàng</a></li>
                                                </ul>
                                            </li>
                                            <li><router-link @click.native="hideMenu">TIN TỨC - SỰ KIỆN</router-link></li>
                                            <template v-if="!isAuthenticated">
                                                <li><a style="text-transform: uppercase;" href="/login">Đăng nhập</a></li>
                                                <li><router-link style="text-transform: uppercase;" @click.native="hideMenu" to="/register">Đăng ký</router-link></li>
                                            </template>
                                            <template v-else>
                                                <li><router-link to="/profile" style="color: black; text-transform: unset; text-decoration: underline;">{{currentUser.username}}</router-link></li>
                                                <li><a style="color: black; text-transform: uppercase;" v-on:click="logout()">Thoát</a></li>
                                            </template>
                                        </ul>
                                    </div>
                                </div>
                            </div> -->
            </div>
          </div>
          <div class="logo-mobile">
            <a href="/"><img src="@/assets/images/logo.svg" class="logo-img" alt=""/></a>
            <div v-on:click="isClick = !isClick" class="humberger">
              <span class="line"></span>
              <span class="line"></span>
              <span class="line"></span>
            </div>
          </div>
          <div v-if="isClick" class="menu-mobile">
            <ul class="main-menu-mobile">
              <li class="menu-item">
                <router-link class="menu-link" @click.native="hideMenu" to="/">TRANG CHỦ</router-link>
              </li>
              <li class="menu-item">
                <a class="menu-link" href="#" style="text-transform: uppercase;" role="menuitem">Giới thiệu</a>
                <ul class="sub-menu">
                  <li class="menu-item">
                    <router-link
                      class="menu-link"
                      style="text-transform: uppercase;"
                      @click.native="hideMenu"
                      to="/about"
                      >Lịch sử hình thành và phát triển</router-link
                    >
                  </li>
                  <li class="menu-item">
                    <router-link
                      class="menu-link"
                      style="text-transform: uppercase;"
                      @click.native="hideMenu"
                      to="/auctioneers"
                      >Danh sách đấu giá viên</router-link
                    >
                  </li>
                </ul>
              </li>
              <li class="menu-item">
                <router-link class="menu-link" @click.native="hideMenu" to="/auction/room"
                  >THÔNG BÁO MỜI ĐẤU GIÁ</router-link
                >
              </li>
              <li class="menu-item"><a class="menu-link blinking" href="/auction/room">PHÒNG ĐẤU GIÁ</a></li>
              <li class="menu-item">
                <a href="#" class="menu-link" role="menuitem">THỦ TỤC SAU ĐẤU GIÁ</a>
                <ul class="sub-menu">
                  <li class="menu-item">
                    <router-link
                      @click.native="hideMenu"
                      class="menu-link"
                      style="text-transform: uppercase;"
                      to="/auction/result"
                      >Kết quả đấu giá</router-link
                    >
                  </li>
                  <li class="menu-item">
                    <a class="menu-link" style="text-transform: uppercase;" href="#">Hợp đồng mua bán tài sản</a>
                  </li>
                  <li class="menu-item">
                    <a class="menu-link" style="text-transform: uppercase;" href="#">Bàn giao tài sản</a>
                  </li>
                  <li class="menu-item">
                    <a class="menu-link" style="text-transform: uppercase;" href="#">Hỗ trợ giao hàng</a>
                  </li>
                </ul>
              </li>
              <li class="menu-item"><router-link @click.native="hideMenu">TIN TỨC - SỰ KIỆN</router-link></li>
              <template v-if="!isAuthenticated">
                <li class="menu-item">
                  <a class="menu-link" style="text-transform: uppercase;" href="/login">Đăng nhập</a>
                </li>
                <li class="menu-item">
                  <router-link
                    class="menu-link"
                    style="text-transform: uppercase;"
                    @click.native="hideMenu"
                    to="/register"
                    >Đăng ký</router-link
                  >
                </li>
              </template>
              <template v-else>
                <li class="menu-item">
                  <router-link
                    @click.native="hideMenu"
                    class="menu-link"
                    to="/profile"
                    style="color: black; text-transform: unset; text-decoration: underline;"
                    >{{ currentUser.username }}</router-link
                  >
                </li>
                <li class="menu-item">
                  <a class="menu-link" style="color: black; text-transform: uppercase;" v-on:click="logout()">Thoát</a>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- Header End -->
  </header>
</template>

<script>
import { destroyToken } from '@/common/jwt';
import { mapGetters } from 'vuex';
import Login from './Login';
import { SET_TIME } from '@/store/actions.type';
import timeDotGov from '@/common/api/time';
export default {
  components: { Login },
  name: 'TopBar',
  props: ['loading'],
  data() {
    return {
      date1: '',
      clickIs: '',
      isClick: false,
      scrollPosition: 0
    };
  },
  computed: {
    ...mapGetters(['currentUser', 'isAuthenticated'])
  },
  mounted() {
    window.addEventListener('scroll', this.updateScroll);
  },
  created() {
    this.syncClock();
  },
  methods: {
    hideMenu() {
      this.isClick = false;
    },
    syncClock() {
      timeDotGov.clockController.checkservertime();
      var _this = this;
      setInterval(function() {
        if (timeDotGov.data.currentTime) {
          let d = timeDotGov.clockController.runningclocks(true);
          if (d) {
            _this.$store.dispatch(SET_TIME, d.timestamp);
            _this.date1 = d.now;
            if (!_this.loading) _this.$emit('update:loading', true);
          }
        }
      }, 20);
    },
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    goProfile() {
      this.$router.push('/profile');
    },
    logout() {
      destroyToken();
      window.location = '/home';
    },
    showMenu() {
      this.isClick = !this.isClick;
    },
    showRegister() {
      this.$router.push('/register');
    },
    showLogin() {
      this.$modal.show('modal-login');
    }
  }
};
</script>
<style scoped>
.c-in {
  display: block !important;
}
.m-in {
  background: white;
}
.page-current {
  background-color: royalblue;
}
</style>



// WEBPACK FOOTER //
// src/components/TopBar.vue